export function showTotal(total: number): string {
    return `Total de registros: ${total}`;
}
